import { Box, makeStyles, Paper, Typography, useMediaQuery } from "@material-ui/core";
import { useCallback, useEffect } from "react";
import { useParams } from "react-router-dom";
import InfoIcon from "src/components/Icon/InfoIcon";
import { THEME_MODE } from "src/config/constants";
import { useUserAnalysisSelector } from "src/context/monitoring/userAnalysisContext";

const useStyles = makeStyles((theme) => ({
  paper: {
    backgroundColor: theme.palette.type === THEME_MODE.DARK ? "#0C4981" : "#7994C1",
    display: "flex",
    flexWrap: "wrap",
  },
  value: {
    fontSize: "28px",
    color: "#FFFFFF",
    fontWeight: 500,
  },
  divider: {
    color: "#408CEC",
    width: "1px",
    margin: "0rem 1rem",
  },
  content: {
    width: "20%",
    [theme.breakpoints.only("sm")]: {
      width: "33.33%",
    },
    [theme.breakpoints.only("xs")]: {
      width: "100%",
    },
  },
}));

export default function UserAnalysisOverview() {
  const cls = useStyles();
  const { pool } = useParams();
  const smDown = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const onlyXs = useMediaQuery((theme) => theme.breakpoints.only("xs"));

  const { fetchDataUserAnalysisOverview } = useUserAnalysisSelector((state) => state.fetch);
  const selector = useCallback(
    (state) => {
      if (!state.dataOverview[pool]) return [];
      return state.dataOverview[pool];
    },
    [pool]
  );
  const dataRender = useUserAnalysisSelector(selector);

  useEffect(async () => {
    await fetchDataUserAnalysisOverview(pool);
  }, [pool]);

  function Content({ label, title, value, ...props }) {
    return (
      <Box className={cls.content} {...props}>
        <Box display="flex" justifyContent="flex-start" alignItems="center">
          <Typography style={{ color: "#D7DFEC" }}>{label}&nbsp;</Typography>
          <InfoIcon title={title} style={{ color: "#D7DFEC" }} />
        </Box>
        <Typography className={cls.value}>{value}</Typography>
      </Box>
    );
  }

  return (
    <Paper className={cls.paper}>
      <Content label="Total Users" title="The total number of users of all time." value={dataRender.totalUser} />
      <Content
        mt={onlyXs ? 1 : 0}
        label="Active USers"
        title="The total number of users who are currently depositing more than 10 USD in the lending pool."
        value={dataRender.activeUser}
      />
      <Content
        mt={onlyXs ? 1 : 0}
        label="Deposit-only users"
        title="The total number of active users who are currently borrowing less than 10 USD from the lending pool."
        value={dataRender.justDepositUsers}
      />
      <Content
        mt={smDown ? 1 : 0}
        label="Borrowing users"
        title="The total number of active users who are currently borrowing more than 10 USD from the lending pool."
        value={dataRender.borrowUsers}
      />
      <Content
        mt={smDown ? 1 : 0}
        label="Lazy users"
        title="The total number of active users who have not performed any transaction in the last 30 days."
        value={dataRender.lazyUsers}
      />
    </Paper>
  );
}
